import { Helmet } from 'react-helmet-async';
import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import AboutSection from '../Elements/AboutSection';
import VisionMission from '../Elements/VisionMission';
import ServicesGrid from '../Elements/ServicesGrid';
import Achievements from '../Elements/Achievements';
import '../../styles/pages/About.css';

var bnrimg = require('./../../images/banner/5.jpg');


class About extends React.Component {
    componentDidMount() {
        function loadScript(src) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            });
        }
        loadScript('/assets/js/custom.js');
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>bs clads</title>
                    <meta name="description" content="Learn about bs clads. The essence of architectural design will always be about people and how they live. It is about creating sustainable, modern facades and cladding." />
                </Helmet>
                <Header />
                <div className="page-content">
                    <Banner title="About Company" pagename="About Us" description="The essence of architectural design will always be about people and how they live. It is about creating sustainable, modern facades and cladding." bgimage={bnrimg}/>
                    <AboutSection showButton={false} />
                    <VisionMission />
                    <ServicesGrid />
                    <Achievements />
                </div>
                <Footer />
            </>
        );
    }
}

export default About;
